import React, {Component} from 'react';

import ChildHeaderForm from "../Base/ReactChildHeaderForm";
import ChildOutcomes2 from "./ReactChildOutcomes2";
import SpinnerDiv from "ui/SpinnerDiv";
import {checkError} from 'root/DataFunctions/BaseDataFns'

export default class UpdateOutcomesPage extends Component
{
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 0 ;

		if ( this.state == null )
		{
			this.state = { 
					loading: true,
                	loadingofr: true,
					child: {},
	                ofr: {},
					ofr_id: this.props.ofr_id
				} ;			
		}
		else
		{
			this.state.loading = true ;
            this.state.loadingofr = true ;
			this.state.child = {} ;
            this.state.ofr = {} ;
			this.state.ofr_id = this.props.ofr_id ;
		}
	}

    UNSAFE_componentWillMount()
	{
        if ( this.props.workitem_id != null && this.props.workitem_id != 0)
        {
            this.getDataUsingWorkitem( this.props.workitem_id );
        }
		else if ( this.props.child_id != null && this.props.child_id != 0)
		{
			this.getDataUsingChildId ( this.props.child_id, this.props.ofr_id );
		}

    }

    UNSAFE_componentWillReceiveProps(nextProps)
	{
		if ( nextProps.value != this.props.value )
		{
			var isValid = this.isValueValid(nextProps.value) ;
		
			// Set our initial validity state
			this.setState ( { val: nextProps.value, valid: isValid }) ;
		}
	}

    getDataUsingWorkitem( workitemid )
    {
        // Globals are defined in the globals.js class
        var root = Globals.APIFolder ;

        var returnUrl = atob(this.props.return_url);

        $.ajax({
            type: 'GET',
            url: root + '/workitems/'+workitemid,
            data: { },
            success:(data)=>{

            if ( checkError ( data ))
        {
            var workitemData = data.metadata ;

            var child_id = workitemData.child_id ;
            var ofr_id = workitemData.ofr_id ;

            this.getDataUsingChildId(child_id, ofr_id) ;
        }
    else
        {
            location.assign ( returnUrl ) ;
        }
    },
        error:(jqXHR, textStatus, error)=>{

        handleAjaxError(jqXHR, textStatus, error, returnUrl) ;
    }
    });
    }

	getDataUsingChildId( child_id, ofr_id )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;

    	$.ajax({
    		  type: 'GET',
    		  url: root + '/children/' + child_id + '?include-needs&include-flags&include-esw&include-school&include-teacher' ,
    		  data: { },
    		  success:(data)=>{

    			// We've got something back, so set the data field in the REACT component STATE
    			// THis will be used in the RENDER function
    			  if ( checkError (data))
				  {
                        var childrec = data.data[0] ;

                        this.getOutcomeData(ofr_id, child_id, childrec) ;
				  }

    		  },
    		  error:(jqXHR, textStatus, error)=>{

				handleAjaxError (jqXHR, textStatus, error);
	  		  }    		
    	    });

    }

    getOutcomeData( ofr_id, child_id, childrec )
    {
        // Globals are defined in the globals.js class
        var root = Globals.APIFolder ;

        $.ajax({
            type: 'GET',
            url: root + '/outcomes/' + ofr_id ,
            data: { },
            success:(data)=>{

                // We've got something back, so set the data field in the REACT component STATE
                // THis will be used in the RENDER function
                if ( checkError (data))
                {
                    let d = data.data ;

                    if ( d.length == 0 )
                    {
                        this.handleReviewMissing() ;
                    }
                    else
                    {
                        var outcomerec = data.data[0] ;

                        this.setState({ loading: false, child: childrec, ofr_id: ofr_id, ofr: outcomerec });
                    }
                }
            },
            error:(jqXHR, textStatus, error)=>{
                handleAjaxError (jqXHR, textStatus, error);
            }
        });
    }

    closeWorkItem ( workitem )
    {
        // Globals are defined in the globals.js class
        var root = Globals.APIFolder ;

        var returnUrl = atob(this.props.return_url);

        $.ajax({
            type: 'DELETE',
            url: root + '/workitems/' + workitem,
            data: { },
            success:(data)=>{

                if ( checkError ( data ))
                {
                    location.assign ( returnUrl ) ;
                }
                else
                {
                    location.assign ( returnUrl ) ;
                }
            },
            error:(jqXHR, textStatus, error)=>{

                handleAjaxError(jqXHR, textStatus, error, returnUrl) ;
            }
        });
    }

    handleReviewMissing()
    {
        let message = '<p>The Targets review request you are trying to action has been deleted.</p><p>Please click OK to remove this work item from your inbox.</p>'

        let self = this ;

        bootbox.alert({
            size: "large",
            title: "The operation failed",
            message: message,
            callback: function()
            {
                self.closeWorkItem ( self.props.workitem_id ) ;
            }
        })
    }

    doSubmit ( ofr_id )
    {
        const service = "/outcomes/" + ofr_id ;

        const self = this ;

        $.ajax({
            type: 'PUT',
            url: Globals.APIFolder + service,
            data: { status: 'submit' },
            success:(data)=>{

            if ( checkError ( data ))
        {
			bootbox.alert({
				size: "large",
				title: "The operation was successful",
				message: "Target is submitted for approval",
				callback: function()
				{
					var url = atob(self.props.return_url) ;

					location.assign(url);
				}
			})
        }
    },
        error:(jqXHR, textStatus, error)=>{

        handleAjaxError(jqXHR, textStatus, error) ;

    }}) ;
    }

	isTeacher()
	{
		if ( this.props.user_type == 5)
		{
			return true ;
		}
		else
		{
			return false ;
		}	
	}

    isHead()
    {
        if ( this.props.user_type == 6 || this.props.user_type == 3 || this.props.user_type == 2 || this.props.user_type == 11 )
        {
            return true ;
        }
        else
        {
            return false ;
        }
    }

    onSave()
    {
        //let child_id = this.props.child_id ;

        //this.createOutcomeRequest ( child_id) ;
    }

    doApproveItem ( ofr_id )
    {
        // Globals are defined in the globals.js class
        var root = Globals.APIFolder ;

        var service = "/outcomes/" + ofr_id ;

        var self = this ;

        $.ajax({
            type: 'PUT',
            url: root + service,
            data: { status: 'approved' },
            success:(data)=>{
            if ( checkError ( data ))
	        {
                bootbox.alert({
                    size: "large",
                    title: "The operation was successful",
                    message: "Status updated",
                    callback: function()
                    {
                        var url = atob(self.props.return_url) ;

                        location.assign(url);
                    }
                })
       }
    },
        error:(jqXHR, textStatus, error)=>{

        handleAjaxError(jqXHR, textStatus, error) ;

    }}) ;
    }

    onApproveClick( ofr_id )
    {
        var self = this ;
        bootbox.confirm({
            title: "Approve Target?",
            message: "You are about to approve this target<br><br>This will set the status of the target to APPROVED and pass the job to the next stage in the workflow process for payment.<br><br>Are you sure you want to do this?",
            buttons: {
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancel'
                },
                confirm: {
                    label: '<i class="fa fa-check"></i> Confirm'
                }
            },
            callback: function (result)
            {
                if ( result == true )
                {
                    self.doApproveItem (ofr_id) ;
                }
            }
        });
    }

    formElement ()
    {
        var string = "<form class='form' role='form'>" ;

        var style = "style='border-bottom: 1px; border-bottom-style: solid; margin: 5px;'" ;

        if ( last == true )
        {
            style = "style='margin: 5px;'" ;
        }

        string += "<div class='row'" + style + "'><div class='col-md-6' style='padding-top: 10px;'><span>" + "Hello" + "</span></div><div class='col-md-6'></div></div>" ;

        string += "</form>" ;

        return string ;
    }

    doRejectItem ( ofr_id, reason )
    {
        // Globals are defined in the globals.js class
        var root = Globals.APIFolder ;

        var service = "/outcomes/" + ofr_id ;

        var self = this ;

        $.ajax({
            type: 'PUT',
            url: root + service,
            data: { status: 'rejected', reason: reason },
            success:(data)=>{

            if ( checkError ( data ))
        {
            bootbox.alert({
                size: "large",
                title: "The operation was successful",
                message: "Status updated",
                callback: function()
                {
                    var url = atob(self.props.return_url) ;

                    location.assign(url);
                }
            })
        }
    },
        error:(jqXHR, textStatus, error)=>{

        handleAjaxError(jqXHR, textStatus, error) ;

    }}) ;
    }

    formElement ()
    {
        var string = "<div>" ;

        string+= '<h2>Reject targets</h2>' ;

        string+= '<p>You are about to reject the targets to the designated teacher requesting they resubmit.</p>' ;

        string+= '<p>Please enter a reason why you are rejecting these targets so that the teacher can understand why their targets were rejected and can correct and re-submit them</p>' ;

        string += "<form class='form' role='form'>" ;

        var style = "style='border-bottom: 1px; border-bottom-style: solid; margin: 5px;'" ;

        string += '<textarea style="width: 100%; padding: 10px" rows="4"></textarea>';

        string += "</form>" ;
        string += "<div>" ;

        return string ;
    }

    onRejectClick( ofr_id )
    {
        var self = this ;

        var i=0;

        var form = this.formElement () ;

        var modal = bootbox.dialog({
            message: form,
            title: "",
            buttons: [
                {
                    label: "Reject Targets",
                    className: "btn btn-primary pull-left",
                    callback: function() {

                        var textarea = $('div.bootbox-body form.form textarea');

                        var reason = textarea[0].value;

                        self.doRejectItem ( ofr_id, reason ) ;

                        return true;
                    }
                },
                {
                    label: "Close",
                    className: "btn btn-default pull-left",
                    callback: function() {
                    }
                }
            ],
            show: false,
            onEscape: function() {
                modal.modal("hide");
            }
        });

        modal.modal("show");
    }

    onSubmit()
    {
		var self = this ;
		bootbox.confirm({
			title: "Submit Targets to Virtual School Head?",
			message: "You are about send these targets for review by the Virtual School head for approval<br><br>Are you sure you want to do this?",
			buttons: {
				cancel: {
					label: '<i class="fa fa-times"></i> Cancel'
				},
				confirm: {
					label: '<i class="fa fa-check"></i> Confirm'
				}
			},
			callback: function (result)
			{
				if ( result == true )
				{
					self.doSubmit( self.state.ofr_id ) ;
				}
			}
		});
    }

    onCancel()
    {
        var returnURL = atob(this.props.return_url) ;

        location.assign(returnURL);
    }


    instructionsRow()
    {
        var lineList = [] ;

        let text = "Still loading ... " ;

        if ( this.state.loading == false )
        {
            let textStyle = { fontSize: '14px', fontWeight: 'bold', color: '#a94442' } ;
            let textStyleBlue = { fontSize: '16px', color: '#2f71aa' } ;

            switch ( this.state.ofr.status )
            {
                case "1":
                    text = "Please review the targets below and ensure that they are current according to the published guidelines." ;
                    lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
                    break ;
                case "2":
                    text = "This pupil's targets have been submitted by their designated teacher." ;
                    lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
                    text = "Please review the targets and approve or reject them using the buttons below. If you wish to return later, just click the 'Return to Home Page' button to leave the status of this review unchanged.";
                    lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
                    break ;
                case "3":
                    text = "This pupil's targets have been rejected by the Virtual School Head. The reason for this is shown below" ;
                    lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
                    lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyleBlue }, this.state.ofr.reason_for_rejection)) ;
                    break ;
                case "4":
                    text = "This pupil's targets have been approved by the Virtual School Head." ;
                    lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
                    break ;
                default:
                    text = "Please review the targets below and ensure that they are current according to the published guidelines." ;
                    lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
                    break ;
            }
        }

        return React.createElement('div', { key: this.keyCount++, className: 'panel panel-default'},
            React.createElement ( 'div', { key: this.keyCount++ , style: { margin: '15px' } }, lineList));
    }

    statusRow()
    {
        var lineList = [] ;

        let text = "Still loading ... " ;

        if ( this.state.loading == false )
        {
            let textStyle = { fontSize: '14px', fontWeight: 'bold', color: '#a94442' } ;
            let textStyleBlue = { fontSize: '16px', color: '#2f71aa' } ;

            switch ( this.state.ofr.status )
            {
                case "1":
                    text = "This pupil's targets have not yet been reviewed and submitted by their teacher." ;
                    lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
                    break ;
                case "2":
                    text = "This pupil's targets have been submitted by their designated teacher." ;
                    lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
                    text = "Please review the targets and approve or reject them using the buttons below. If you wish to return later, just click the 'Return to Home Page' button to leave the status of this review unchanged.";
                    lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
                    break ;
                case "3":
                    text = "This pupil's targets have been rejected by the Virtual School Head. The reason for this is shown below" ;
                    lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
                    lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyleBlue }, this.state.ofr.reason_for_rejection)) ;
                    break ;
                case "4":
                    text = "This pupil's targets have been approved by the Virtual School Head." ;
                    lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
                    break ;
                default:
                    text = "Please review the targets below and ensure that they are current, according to the published guidelines." ;
                    lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
                    break ;
            }
        }

        return React.createElement('div', { key: this.keyCount++, className: 'panel panel-default'},
            React.createElement ( 'div', { key: this.keyCount++ , style: { margin: '15px' } }, lineList));
    }

    buttonRow ()
    {
        var lineList=[];

        if ( this.props.mode == 'view')
        {
            lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;

            lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3' },
                React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '0px' }, onClick: this.onCancel.bind(this) }, 'Save ')))

        }
        else
        {
        	if ( this.isTeacher())
			{
                lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-5'},null)) ;

                lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-7' },
                    React.createElement('button', { id: 'SaveButton', type: 'button', className: 'btn btn-primary', style: { float: 'right' } , onClick: this.onSubmit.bind(this) }, 'Submit Targets for approval'),
                    React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onCancel.bind(this) }, 'Return to Home Page')))

			}
			else if ( this.isHead())
            {

                switch ( this.state.ofr.status ) {

                    case "2":
                    case "7":

                        lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-5'},null)) ;

                        lineList.push(React.createElement('div', {key: this.keyCount++, className: 'col-md-7'},
                                React.createElement('button', {
                                    id: 'RejectButton',
                                    type: 'button',
                                    className: 'btn btn-danger',
                                    style: {float: 'right'},
                                    onClick: this.onRejectClick.bind(this, this.state.ofr_id)
                                }, 'Reject'),
                                React.createElement('button', {
                                    id: 'SaveButton',
                                    type: 'button',
                                    className: 'btn btn-primary',
                                    style: {float: 'right', marginRight: '10px'},
                                    onClick: this.onApproveClick.bind(this, this.state.ofr_id)
                                }, 'Approve'),
                                React.createElement('button', {
                                    id: 'CancelButton',
                                    type: 'button',
                                    className: 'btn btn-secondary',
                                    style: {float: 'right', marginRight: '10px'},
                                    onClick: this.onCancel.bind(this)
                                }, 'Return to Home Page')))
                            break ;
                    default:
                        lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-5'},null)) ;

                        lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-7' },
                            React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onCancel.bind(this) }, 'Return to Home Page'))) ;

                }
			}
			else
			{
                lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-5'},null)) ;

                lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-7' },
                    React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onCancel.bind(this) }, 'Return to Home Page'))) ;

			}


        }

        return React.createElement('div', { key: this.keyCount++, className: 'panel panel-default'},
        	React.createElement('div', { className: 'row', style: { paddingTop: '15px', paddingBottom: '15px', paddingRight: '15px'}, key: this.keyCount++ }, lineList ));
    }

	renderedComponent()
	{
		var lineList=[];

        let allowChange = true ;
        let showSchool = false ;

		if ( this.isHead())
		{
			allowChange = false ;
			showSchool = true ;
		}

		lineList.push ( React.createElement ( ChildHeaderForm,
			{
				key: 'outcomes_header',
				allowChange: false,
				showAdditionalDetails: false,
				mode: 'view',
				child: this.state.child,
                showSchoolDetails: showSchool,
				return_url: this.props.return_url
			}, null )) ;

        if ( !this.isHead())
        {
            // Only display the instructions row for teachers
            lineList.push(this.instructionsRow());
        }
        else
        {
            // Only display the instructions row for teachers
            lineList.push(this.statusRow());
        }

        var extended = false ;

		if ( this.isHead() )
        {
            extended = true ;
        }

        const isSen = this.state.child.needs !== undefined ;

        lineList.push (
            <ChildOutcomes2
                key='outcomes'
                allowChange={allowChange}
                user_type={this.props.user_type}
                child_id={this.state.child.child_id}
                id='OutcomesForm'
                ofr_id={this.state.ofr_id}
                extended={extended}
                isSen={isSen}
                mode='edit' />
        )

        lineList.push ( this.buttonRow()) ;

        return React.createElement ( 'div', {className: 'panel panel-default panel-base'}, lineList ) ;
	}
	
    render() 
    {
    	this.keyCount = 0 ;
    	
    	if ( this.state.loading == true )
    	{
            return React.createElement(SpinnerDiv);
    	}
    	else
		{
    		return (
                <div className="jumbotron">
                    <p className="med">Update Pupil Targets</p>
                    { this.renderedComponent() }
                </div>
            )
        }
    }
};


